<dx-scroll-view #scrollView
                direction="both"
                showScrollbar="always"
                class="me-1"
                [height]="verticalLaneHeight">
    <div *adaptLoading="loadingItems"
         class="board-container">
        <div class="lane-header-container vertical-lane-container">
            @for (status of showStatuses; track statusTrackBy($index, status)) {
                <div class="vertical-lane">
                    <div class="lane-header">
                        <div class="d-flex align-items-center gap-1">
                            <span [ngClass]="ItemStatuses[status].iconClass"></span>
                            <span>{{ ItemStatuses[status].name }}</span>
                        </div>
                        @if (headerItemsForStatus[status]; as headerItems) {
                            @for (headerItem of headerItems; track headerItem; let idx = $index) {
                                <div class="d-flex align-items-center"
                                     id="suggestionSource-{{ status }}-{{ idx }}"
                                     (mouseenter)="headerItem.tooltipVisible = true">
                                    @if (headerItem.icon) {
                                        <i [ngClass]="headerItem.icon"
                                           (mouseenter)="headerItem.tooltipVisible = true"></i>
                                    }
                                    @if (headerItem.badge; as badge) {
                                        <span class="badge rounded-1 p-1"
                                              [ngClass]="badge.badgeClass">{{ badge.content }}</span>
                                    }
                                    @if (headerItem.tooltip; as tooltip) {
                                        <!-- Use popover instead of tooltip here to allow more control over clickable content -->
                                        <dx-popover target="#suggestionSource-{{ status }}-{{ idx }}"
                                                    position="top"
                                                    showEvent="dxpointerenter"
                                                    [enableBodyScroll]="false"
                                                    [hideEvent]="{
                                                name: 'dxpointerleave',
                                                delay: 300,
                                            }"
                                                    [width]="300"
                                                    [(visible)]="headerItem.tooltipVisible"
                                                    (onContentReady)="onPopoverContentReady($event, headerItem)"
                                                    (onShowing)="popoverCancelHiding = false"
                                                    (onHiding)="onPopoverHiding($event)">
                                            <div *dxTemplate="let content of 'content'">
                                                <div [froalaView]="tooltip.content"></div>
                                                @if (tooltip.contentButton; as btn) {
                                                    <button class="mt-3"
                                                            [ngClass]="btn.buttonClass"
                                                            (click)="btn.onClick?.()"
                                                            [adaptButtonIcon]="btn.iconClass">
                                                        {{ btn.buttonText }}
                                                    </button>
                                                }
                                            </div>
                                        </dx-popover>
                                    }
                                </div>
                            }
                        }
                        @if (status === Backlog) {
                            <button adaptButton="collapseLeft"
                                    adaptTooltip="Hide backlog column"
                                    (click)="hideBacklog()"></button>
                        }
                        @if (inMultipleSelectionMode && itemCountForStatus[status] > 0) {
                            <button class="ms-auto btn btn-link"
                                    [adaptButtonIcon]="hasSelectionForStatus[status] ? 'fal fa-fw fa-square-minus' : 'fal fa-fw fa-square-dashed-circle-plus'"
                                    [adaptTooltip]="isMobileView ? (hasSelectionForStatus[status] ? 'Clear selection' : 'Select all') : undefined"
                                    (click)="toggleSelectAll(status)">
                                <span
                                      class="d-none d-md-inline">{{ hasSelectionForStatus[status] ? "Clear selection" : "Select all" }}</span>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>

        @for (group of itemCollectionGroups; track itemCollectionGroupTrackBy($index, group)) {
            <div class="swimlane"
                 [class.swimlane-visible]="columnGroup !== undefined">
                @if (columnGroup !== undefined) {
                    <h3 class="swimlane-header"
                        data-test="swimlane-header"
                        (click)="group.collapsed = !group.collapsed">
                        <i class="fal {{ group.collapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
                        @if (columnGroup === KanbanGroup.Assignee) {
                            <adapt-link-person [person]="$any(group.key)"
                                               [showImage]="true"
                                               nullValueText="Unassigned"
                                               imageSize="sm"></adapt-link-person>
                        }
                        @if (columnGroup === KanbanGroup.Label && group.key) {
                            <adapt-display-label [label]="$any(group.key)"></adapt-display-label>
                        }
                        @if (columnGroup === KanbanGroup.Team) {
                            @if (asTeam(group.key); as team) {
                                <adapt-link-team-kanban [team]="team"
                                                        [buttonText]="team.name"></adapt-link-team-kanban>
                            } @else {
                                Your personal boards
                            }
                        }
                        @if (columnGroup === KanbanGroup.Board && asBoard(group.key); as board) {
                            <span class="badge item-code"
                                  [class.personal-board]="board.isPersonalBoard">
                                {{ board.itemPrefix }}
                                @if (board.isPersonalBoard) {
                                    <i class="fal fa-lock-alt"
                                       aria-hidden="true"
                                       adaptTooltip="Board is only visible to you"> </i>
                                } @else {
                                    <adapt-team-private-icon [team]="board.team"></adapt-team-private-icon>
                                }
                            </span>
                            {{ board.name }}
                            <!-- assignees are only shown when team board. we only want to show the team link on personal boards -->
                            @if (board.team && !showAssignees) {
                                <span>(<adapt-link-team [team]="board.team"></adapt-link-team>)</span>
                            }
                        }
                        @if (columnGroup !== KanbanGroup.Assignee && columnGroup !== KanbanGroup.Team && !group.key) {
                            Unassigned
                        }
                        <span class="text-muted">{{ group.itemCount }} action{{ group.itemCount !== 1 ? "s" : "" }}</span>
                    </h3>
                }
                <div [collapse]="group.collapsed"
                     (collapsed)="updateScrollView()"
                     (expanded)="updateScrollView()"
                     [isAnimated]="true">
                    <div class="vertical-lane-container">
                        @for (status of showStatuses; track statusTrackBy($index, status)) {
                            <div class="vertical-lane">
                                <dx-sortable group="adaptKanban-{{ group.keyString }}"
                                             [attr.data-test]="'vertical-lane-' + status"
                                             [class]="getVerticalLaneContentClass(status, group)"
                                             [data]="group.items[status]"
                                             (onDragMove)="onDragMoved($event)"
                                             (onDragStart)="onDragStart($event, group)"
                                             (onDragEnd)="onDragEnd($event, group)"
                                             (onReorder)="onOrderChanged($event)">
                                    @for (item of group.items[status]; track itemTrackBy($index, item)) {
                                        <adapt-kanban-card [ngClass]="{
                                                'selected-item': item === selectedItem,
                                            }"
                                                           (itemSelected)="onItemSelected($event)"
                                                           [item]="item"
                                                           [columnItems]="group.items[status]"
                                                           [showAssignee]="showAssignees"
                                                           [highlight]="item.extensions.isOverdue"
                                                           (dialogOpened)="itemDialogOpened.emit($event)"
                                                           (dialogClosed)="itemDialogClosed.emit($event)"
                                                           (contentRendered)="refreshRequired = true; scrollView.instance.update()"
                                                           [inMultipleSelectionMode]="inMultipleSelectionMode"
                                                           [inMultipleSelection]="checkedItems.includes(item)"
                                                           (inMultipleSelectionChange)="inMultipleSelectionChange(item, $event)"
                                                           data-test="kanban-item"></adapt-kanban-card>
                                    }
                                </dx-sortable>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        @if (!items?.length) {
            <div class="ms-3">There are no items matching the filter criteria</div>
        }
    </div>
</dx-scroll-view>
